import React, { Component } from 'react';
import './SelectInputCombo.scss';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import Label from 'Components/forms/label/Label';
import PropTypes from 'prop-types';
import TextField from 'Components/forms/text-field/TextField';
import DropDownList from '../DropDownList/DropDownList';
import Checkbox from 'Components/forms/checkbox/Checkbox.jsx';
import 'antd/dist/reset.css';
import { COLORS } from "Constants/BIDashboardConstants"

class SelectInputCombo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      inputHeadings: [],
      selectedInput: null,
      length: 0,
      max: props.id > 0 && props.jsonHeadings[props.id].textAreaMaxLength !== undefined ? props.jsonHeadings[props.id].textAreaMaxLength : 500,
      className: 'input-text-area valid-input-area',
      textAreaValue: '',
      secondaryOptions: [{ value: 'something', name: 'Something' }, { value: 'something_else', name: 'Something Else' }, { value: 'third_thing', name: 'Third Something' }, { value: 'all', name: 'All' }],
      isOpen: false,

      canvasSelectedIndex: 0,
      selectedAccordianIndex: -1,
      activeRuleCheckBox: false,
      addClass: false,
      visible: false,
    };

    this.attachBindings();
  }
  componentDidMount() {
    if (this.props.id !== undefined && this.props.selectionList !== undefined) {
      this.setState({
        secondaryOptions: this.props.selectionList == undefined ? [{ value: 'something', text: 'Something' }, { value: 'something_else', text: 'Something Else' }, { value: 'third_thing', text: 'Third Something' }, { value: 'all', text: 'All' }] : this.props.selectionList,
        selectedInput: null,
        length: 0,
        max: this.props.jsonHeadings !== undefined && this.props.jsonHeadings.length > 0 && this.props.jsonHeadings[this.props.id] !== undefined && this.props.jsonHeadings[this.props.id].textAreaMaxLength !== undefined ? this.props.jsonHeadings[this.props.id].textAreaMaxLength : 500,
      });
    }
    this.props.onDisableNextStep(true);
    if (this.refs.notes !== undefined) this.refs.notes.value = '';
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps !== undefined) {
      if (nextProps.id !== undefined && this.props.id !== nextProps.id) {
        if (this.refs.notes !== undefined) this.refs.notes.value = '';
        this.setState({
          secondaryOptions: nextProps.selectionList == undefined ? [{ value: 'something', text: 'Something' }, { value: 'something_else', text: 'Something Else' }, { value: 'third_thing', text: 'Third Something' }, { value: 'all', text: 'All' }] : nextProps.selectionList,
          selectedInput: null,
          length: 0,
          className: 'input-text-area valid-input-area',

          max: nextProps.jsonHeadings !== undefined && nextProps.jsonHeadings[nextProps.id] !== undefined && nextProps.jsonHeadings[nextProps.id].textAreaMaxLength !== undefined ? nextProps.jsonHeadings[nextProps.id].textAreaMaxLength : 500,
        });
        this.props.onDisableNextStep(true);
      } else if (nextProps.id !== undefined && this.props.id == nextProps.id && (this.props.isDataUploaded !== nextProps.isDataUploaded || this.props.isError != nextProps.isError)) {
        if (this.refs && this.refs.notes) { this.refs.notes.value = ''; }
        this.setState({
          secondaryOptions: nextProps.selectionList == undefined ? [{ value: 'something', text: 'Something' }, { value: 'something_else', text: 'Something Else' }, { value: 'third_thing', text: 'Third Something' }, { value: 'all', text: 'All' }] : nextProps.selectionList,
          selectedInput: null,
          length: 0,
          className: 'input-text-area valid-input-area',
          max: nextProps.jsonHeadings !== undefined && nextProps.jsonHeadings[nextProps.id] !== undefined && nextProps.jsonHeadings[nextProps.id].textAreaMaxLength !== undefined ? nextProps.jsonHeadings[nextProps.id].textAreaMaxLength : 500,
        });
        this.props.onDisableNextStep(true);
      } else if (nextProps.id !== undefined && this.props.id == nextProps.id && (this.props.selectionList !== nextProps.selectionList || nextProps.selectionList !== this.state.selectionList)) {
        this.setState({
          secondaryOptions: nextProps.selectionList == undefined ? [{ value: 'something', text: 'Something' }, { value: 'something_else', text: 'Something Else' }, { value: 'third_thing', text: 'Third Something' }, { value: 'all', text: 'All' }] : nextProps.selectionList,

          max: nextProps.jsonHeadings !== undefined && nextProps.jsonHeadings[nextProps.id] !== undefined && nextProps.jsonHeadings[nextProps.id].textAreaMaxLength !== undefined ? nextProps.jsonHeadings[nextProps.id].textAreaMaxLength : 500,
        });
      }
    }
  }

  attachBindings() {
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.charCount = this.charCount.bind(this);
    this.toggleThisAccordion = this.toggleThisAccordion.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.updateSelectedPages = this.updateSelectedPages.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  showModal = (index) => {
    this.setState({
      visible: true,
      canvasSelectedIndex: index,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  updateSelectedPages(selectedPages) {
    this.setState({
      selectedPages,
      addClass: true,
    });
  }

  toggleThisAccordion = (id) => {
    this.setState({ isOpen: !this.state.isOpen, selectedAccordianIndex: id });
  }
  charCount(event) {
    if (this.maxLength(document.getElementById('textArea'))) {
      this.props.onDisableNextStep(false);
      this.setState({
        length: event.target.value.length,
      });
      if (event.target.value.length > this.state.max) {
        this.props.onDisableNextStep(true);
        this.setState({ className: 'input-text-area error-input-area' });
      } else { this.setState({ className: 'input-text-area valid-input-area' }); }
      this.setState({
        textAreaValue: event.target.value,
      });
      this.props.onEndEdit(this.state.selectedInput == undefined ? this.state.secondaryOptions[0] : this.state.selectedInput, event.target.value, this.props.actualSelectedObjectId, this.props.caseNumber);

      if (this.maxLength(document.getElementById('textArea'))) {
        this.props.onDisableNextStep(false);
        this.setState({
          length: event.target.value.length,
        });
        if (event.target.value.length > this.state.max) {
          this.props.onDisableNextStep(true);
          this.setState({ className: 'input-text-area error-input-area' });
        } else { this.setState({ className: 'input-text-area valid-input-area' }); }
        this.setState({
          textAreaValue: event.target.value,
        });
        this.props.onEndEdit(this.state.selectedInput == undefined ? this.state.secondaryOptions[0] : this.state.selectedInput, event.target.value, this.props.id, this.props.caseNumber);
      }
      if (event.target.value.length == 0 || !event.target.value.replace(/\s/g, '').length) {
        this.props.onDisableNextStep(true);
        this.setState({ className: 'input-text-area error-input-area' });
      }
    }
  }

  maxLength(el) {
    if (!('maxLength' in el)) {
      const max = el.attributes.maxLength.value;
      el.onkeypress = function () {
        if (this.value.length >= max) return false;
      };
    }
    return true;
  }

  onSelectionChange(option) {
    let selectedOption;
    if (option.value == undefined) { selectedOption = this.state.secondaryOptions.find((item) => item.value === option); } else { selectedOption = this.state.secondaryOptions.find((item) => item.value === option.value); }

    if (selectedOption) {
      this.setState({ selectedInput: selectedOption });
    }
    this.props.onEndEdit(selectedOption, this.state.textAreaValue, this.props.actualSelectedObjectId, this.props.caseNumber);
  }

  toggleCheckbox() {
    if (!this.state.activeRuleCheckBox) {
      this.props.attachDocumentPage(this.props.selectedIndex, 'push');
    } else {
      this.props.attachDocumentPage(this.props.selectedIndex, 'pop');
    }
    this.setState({
      activeRuleCheckBox: !this.state.activeRuleCheckBox,
    });
  }
  render() {
    const { jsonHeadings } = this.props;
    const { max, length } = this.state;
    const id = this.props.id;
    const extraStyle = { float: 'none' };

    const formControlGroup = jsonHeadings[id] !== undefined && jsonHeadings[id].dataColumns !== undefined && jsonHeadings[id].dataColumns?.map((dataColumn) => {
      return (
        <div key={dataColumn.key}>
          {dataColumn.displayType == 'DROPDOWN' && <TextField
            fieldClass="field--fixed-width"
            htmlFor={dataColumn.name}
            labelContent={<span data-radium>
              <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: '#7C7C89' }} htmlFor="user-permissions-list" labelClass="field-label checkbox-group-parent-label">{jsonHeadings[id].dataColumns[0].name}</Label>
            </span>}
            width={dataColumn.width}
          >
            <div style={{ marginTop: 11, marginBottom: 11 }}>
              <SelectInput
                dataList={this.state.secondaryOptions}
                promptText={this.state.secondaryOptions[0].text}
                wrapperClass="select-menu__form reports"
                extraClass="option-box"
                handleSelection={this.onSelectionChange}
                selectedItem={this.state.selectedInput}
              />
            </div>
          </TextField>}
          {dataColumn.displayType == 'DROPDOWNLIST' && <DropDownList
            dropDownList={this.state.secondaryOptions}
            selectedItemText={this.state.selectedInput == null ? this.state.secondaryOptions[0].text : this.state.selectedInput.text}
            selectDropdownItem={this.onSelectionChange}
            extraStyle={{ width: dataColumn.width, left: dataColumn.left }}
            wrapperButtonStyle={{ left: dataColumn.left }}
            actionPositionStyle={{ position: 'relative' }}
          />}
          {dataColumn.displayType == 'DROPDOWNLISTPEND' && <DropDownList
            dropDownList={this.state.secondaryOptions}
            selectedItemText={this.state.selectedInput == null ? this.state.secondaryOptions[0].text : this.state.selectedInput.text}
            selectDropdownItem={this.onSelectionChange}
            extraStyle={{ width: dataColumn.width, left: dataColumn.left }}
            wrapperButtonStyle={{ left: dataColumn.left }}
            actionPositionStyle={{ position: 'relative' }}
          />}
          {dataColumn.displayType == 'COMMENTS' && <TextField
            fieldClass="field--fixed-width"
            htmlFor={dataColumn.name}
            labelContent={<span data-radium>
              <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="user-permissions-list" labelClass="field-label checkbox-group-parent-label-note">{jsonHeadings[id].dataColumns[1].name}</Label>
            </span>}
            width={dataColumn.width}
            display="inline-block"
          >
            <span style={{ float: 'right', fontSize: 12, fontWeight: 400, color: `${COLORS.oneGp.black}` }}>{this.state.length}/{this.state.max}</span>
            <div style={{ marginBottom: 11 }}><textarea ref="notes" tabIndex='0' id="textArea" maxLength={this.state.max} onChange={this.charCount} style={{ width: dataColumn.width }} className={this.state.className} /></div>
            </TextField>}
          {
            dataColumn.displayType == 'CHECKBOX' && <TextField
              htmlFor="comment-box"
            >
              <Checkbox
                label={dataColumn.description}
                id="activeRuleCheckBox"
                isChecked={this.state.activeRuleCheckBox}
                onChange={this.toggleCheckbox}
                extraLabelStyle={{
                  color: '#262aff',
                  background: 'unset',
                  fontSize: 'larger',
                }}
              />
            </TextField>
          }

        </div>
      );
    });
    return (
      <div >
        {formControlGroup}
      </div>
    );
  }
}
SelectInputCombo.propTypes = {
  jsonHeadings: PropTypes.array,
};

SelectInputCombo.defaultProps = {
  jsonHeadings: [],
};
export default SelectInputCombo;
